import Header from '@com/common/Header.vue';
import { userReport } from '@api/exercise';
import { appPort } from '@/widget/index';
export default {
    components: {
        Header
    },
    data() {
        return {
            reportEchart: null,
            reportList: [],
            reportNumber: [],
            serialNumber: 1,
            isApp: appPort(),
            defaultList: [
                { tagName: '冠心病', medicaseCount: 0 },
                { tagName: '心律失常', medicaseCount: 0 },
                { tagName: '心里衰竭', medicaseCount: 0 },
                { tagName: '高血压', medicaseCount: 0 },
                { tagName: '心血管影像', medicaseCount: 0 }
            ],
            departmentId: this.$route.query.depId || 1
        };
    },
    created() {
        /* 随机获取文案图片 */
        const num = Math.floor(Math.random() * 7 + 1);
        this.serialNumber = num;
    },
    methods: {
        /* 获取练习报告数据 */
        getList() {
            // console.log(this.$route.query.depId, '11111');
            this.$showLoading();
            userReport({ departmentId: this.departmentId }).then(res => {
                this.$hideLoading();
                if (res.code === 200) {
                    const reportData = res.data;
                    this.reportNumber = reportData;
                    if (reportData.distributions.length !== 0) {
                        this.reportList = reportData.distributions;
                        this.setEcharts(this.reportList);
                    }
                    else {
                        this.setEcharts(this.defaultList);
                    }
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        setEcharts(reportList) {
            const oneMedicase = reportList[0].medicaseCount;
            const remainder = oneMedicase % 5;
            const maxVal = remainder !== 0 ? oneMedicase + 5 - remainder : oneMedicase;
            if (this.reportEchart) {
                this.reportEchart.resize();
            }
            else {
                const echarts = require('echarts');
                this.reportEchart = echarts.init(this.$refs.reportChart);
                this.reportEchart.setOption({
                    textStyle: {
                        /* 坐标值颜色 */
                        color: '#B1B1B3'
                    },
                    grid: {
                        left: '5%',
                        top: '12%',
                        bottom: '15%'
                    },
                    xAxis: {
                        min: 0,
                        max: maxVal < 25 ? 25 : maxVal,
                        axisLine: {
                            /* 轴线颜色类型 */
                            show: true,
                            color: '#B1B1B3',
                            lineStyle: {
                                color: '#E1E2E6'
                            }
                        }
                    },
                    yAxis: {
                        type: 'category',
                        axisTick: {
                            /* 刻度线隐藏 */
                            show: false
                        },
                        axisLine: {
                            /* 轴线颜色类型 */
                            lineStyle: {
                                color: '#E1E2E6',
                                width: 1
                            }
                        },
                        data: reportList.map(item => item.tagName),
                        axisLabel: {
                            interval: 0,
                            margin: -2,
                            textStyle: {
                                color: '#B1B1B3',
                                verticalAlign: 'bottom',
                                align: 'left',
                                padding: [0, 0, 15, 0],
                                fontSize: '14'
                            }
                        }
                    },
                    series: [
                        {
                            type: 'bar',
                            data: reportList.map(item => item.medicaseCount),
                            barWidth: 18,
                            color: '#FF6600',
                            label: {
                                show: true,
                                position: 'right',
                                valueAnimation: true,
                                color: '#626366',
                                fontSize: '13'
                            }
                        }
                    ]
                });
            }
        }
    },
    mounted() {
        this.getList();
    }
};
